$(document).ready(function() {
  $('.reset-password #new_user').validate({
    errorPlacement: function (error, element) {
      error.addClass('red-text')
      error.insertAfter(element);
    },
    rules: {
      'user[email]': {
       required: {
        depends: function(){
          $(this).val($.trim($(this).val()));
          return true;
        }
       },
       email: true
      }
    },
    highlight: function(element) {
      $(element).addClass('border-red');
    },
    unhighlight: function(element) {
      $(element).removeClass('border-red');
    },
    messages:{
      'user[email]':{
        required: 'メールを入力してください。',
        email: 'メールは不正な値です。',
      }
    }
  });
});
